import React, { FC } from 'react';

import { CommandPopoverButton, ICommandPopoverButtonProps } from '../../../components';
import { ToggleWPageForm } from './ToggleWPageForm';
import { useWPageState } from '../hooks';

export type IToggleWPageButtonProps = Omit<
  ICommandPopoverButtonProps,
  'commandName' | 'active' | 'enabled' | 'attrs' | 'onSelect' | 'popoverContent'
>;

export const ToggleWPageButton: FC<IToggleWPageButtonProps> = (props) => {
  const { isEditing, wPageViewClickHandlerProps, attrs, active, enabled, handleRemove, handleSubmit } = useWPageState();

  return (
    <CommandPopoverButton
      {...props}
      commandName="toggleWPage"
      active={active}
      enabled={enabled}
      popoverContent={
        <ToggleWPageForm onRemove={active ? handleRemove : undefined} initialValues={attrs} onSubmit={handleSubmit} />
      }
    />
  );
};
